<div class="search-item-wrapper">

  <div class="tag-wrapper">
    <app-color-tag [tagTitle]="searchItem().type" [withBMargin]="false"></app-color-tag>
    <app-divider></app-divider>
    <app-is-new-tag [newsDate]="(searchItem().publishDate || searchItem().date )  | onlyDate"></app-is-new-tag>
  </div>
  <a (click)="onNavigate()" [routerLink]="[itemLink()]">
    <p [searchedWord]="searchPrompt()"
       [text]="searchItem().title"
       appHighlight
       class="search-item-title text-l text--semi-bold"
       classToApply="selected"></p>
    <p [innerHTML]="description() | removeHtml"
       [searchedWord]="searchPrompt()"
       [text]="description()"
       appHighlight
       class="search-item-description"
       classToApply="selected"
    ></p>
  </a>
</div>
